import { Injectable } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  private BASE_URL: string = environment.API_URL;
  // private BASE_URL: string = 'http://52.66.143.47:8000/';
  //private BASE_URL: string = "http://3.108.44.158:8000/uat/";
   //private BASE_URL: string = "http://13.127.121.254:8000/qa/";
  private errorData: any = {}; 
  adminLoginData:any = JSON.parse(localStorage.getItem('adminLoginPass') || '[]');
  data:any= "";
  contentAuth="";
  username: string = this.adminLoginData.email; password: string = this.adminLoginData.pass;
  //username:string="shubham.j@unikove.com";password:string="shubh@123";
  authorizationData :any= 'Basic ' + btoa(this.username + ':' + this.password);

  httpOptions = {
    headers: new HttpHeaders({ 'Authorization': this.authorizationData, 'Content-Type': 'application/json'
  })
  };
  httpOptions1 = {
    headers: new HttpHeaders({ 'Authorization': this.authorizationData})
              };

  lastSelectedTab:BehaviorSubject<any>=new BehaviorSubject<any>(0)  
           
  constructor(private http:HttpClient,private router:Router) { }

  selectedUsers:BehaviorSubject<any>=new BehaviorSubject<any>(0) 

  /**********capsule listing for select in course************/
  capsuleListing(search_text:any,order_by:any,order:any): Observable<any>{
    return this.http.post(this.BASE_URL+'content-capsules/active-list',{"search_text" : search_text,"order_by" : order_by,"order" : order},this.httpOptions);
   }
   creatModule(formData:any,page:any): Observable<any>{
     if(page =='edit'){
      return this.http.post(this.BASE_URL+'edit/module',formData,this.httpOptions);
     }else{
      return this.http.post(this.BASE_URL+'create/module',formData,this.httpOptions);
     }
    
   }
   public courseList(course_name: any, is_active: any, course_status: any, order_by: any, order: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'course/list/by/status', { "course_name": course_name, "is_active": is_active, "course_status": course_status, "order_by": order_by, "order": order }, this.httpOptions);
  }
  /***********Change status in active and deactive ******/
  public changeIsActiveVal(course_id: any, is_active: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'change/course/active/status', { "course_id": course_id, "is_active": is_active }, this.httpOptions);
  }
  public changeAssIsActiveVal(assessment_id: any, is_active: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'active/assessment', { "assessment_id": assessment_id, "is_active": is_active }, this.httpOptions);
  }
  /***********Delete course by id ******/
  public deletesCourse(course_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'delete/course', { "course_id": course_id }, this.httpOptions);
  }
  public deleteAssessment(assessment_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'delete/assessment', { "assessment_id": assessment_id }, this.httpOptions);
  }
  /****delete module *****/
  public getModulesDetail(module_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'module/details', { "module_id": module_id }, this.httpOptions);
  }
  /****get module *****/
  public getModules(course_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'get/modules', { "course_id": course_id }, this.httpOptions);
  }
   /****delete module *****/
   public deletesModules(module_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'delete/module-submodule', { "module_id": module_id }, this.httpOptions);
  }
   /***********get course detail by id ******/
  public CourseDetail(course_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'view/course', { "course_id": course_id }, this.httpOptions);
  }
  /***********course publish ******/
  public CoursePublish(course_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'publish/course', { "course_id": course_id }, this.httpOptions);
  }
  public AssessmentPublish(assessment_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'change/assessment/status', { "assessment_id": assessment_id, status:1 }, this.httpOptions);
  }
  /***********course publish ******/
  public AssignUsers(course_id: any,userId:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'course/assign-to-users', { "course_id": course_id,"users":userId }, this.httpOptions);
  }
  public AssignAssmntToUsers(assessment_id: any,userId:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'assessment/assign-to-users', { "assessment_id": assessment_id,"users":userId }, this.httpOptions);
  }
   /***********course publish ******/
   public DeAssignUsers(course_id: any,userId:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'deassign/course', { "course_id": course_id,"user_id":userId }, this.httpOptions);
  }
   public AssesmntDeAssignUsers(assessment_id: any,userId:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'assessment/deassign-to-users', { "assessment_id": assessment_id,"user_id":userId }, this.httpOptions);
  }
  //  /***********course publish ******/
  //  public ViewUsers(course_id: any,search_by:any): Observable<any> {
  //   return this.http.post(this.BASE_URL + 'view/users-progress', { "course_id": course_id ,"search_by":search_by}, this.httpOptions);
  // }
   /***********course publish ******/
   public ViewUsers(course_id: any,search_by:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'view/users-progress', { "courseId": course_id ,"search":"","order": "user_name","order_by": "asc","filter_by_org":""}, this.httpOptions);
  }

  /******create course function *****/
  createCourse(loginForm: any,status:any,page:any) {
    if(page =='edit'){
      return this.http.post<any>(`${this.BASE_URL}edit/course`,  loginForm , this.httpOptions)
      .pipe(map(data => {
        if (data) {
          return data;
        }
      }),
        catchError(this.handleError)
      );
    }else{
      return this.http.post<any>(`${this.BASE_URL}create/course`,  loginForm , this.httpOptions)
      .pipe(map(data => {
        if (data) {
          return data;
        }
      }),
        catchError(this.handleError)
      );
    }
  }
  dublicateCourse(loginForm:any) {
      return this.http.post<any>(`${this.BASE_URL}create/course`,  loginForm , this.httpOptions)
      .pipe(map(data => {
        if (data) {
          return data;
        }
      }),
        catchError(this.handleError)
      );
  }
  dublicateAssessment(loginForm:any) {
    return this.http.post<any>(`${this.BASE_URL}duplicate/assessment`,  loginForm , this.httpOptions)
    .pipe(map(data => {
      if (data) {
        return data;
      }
    }),
      catchError(this.handleError)
    );
}
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    this.errorData = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.'
    };
    return throwError(this.errorData);
  }
  public AssignCourse( userId: any,course_id: any,): Observable<any> {
    return this.http.post(this.BASE_URL + 'course/assign-course', { "course_id": course_id, "users": userId }, this.httpOptions);
  }
  public viewUsersProgress(course_id: any,searchText:any, order:any, order_by:any,filter_by_org:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'view/users-progress', { "courseId": course_id ,"search":searchText, "order":order, "order_by":order_by,"filter_by_org":filter_by_org}, this.httpOptions);
  }
  public viewAsmntAssignedUsers(assessment_id: any,searchText:any, order:any, order_by:any,filter_by_org:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/assessmnt/list', { "assessment_id": assessment_id ,"search":searchText, "order":order, "order_by":order_by,"filter_by_org":filter_by_org}, this.httpOptions);
  }
  public courseEndDateUpdate(course_id: any,enddate:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'update-course', { "course_id": course_id ,"enddate":enddate, }, this.httpOptions);
  }
  public manageAsseesment(searchText: any, is_active: any, capsules_status: any, order_by: any, order: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'search/assessment', { "searchText": searchText, "is_active": is_active, "capsules_status": capsules_status, "order_by": order_by, "order": order }, this.httpOptions);
  }
}
